<template>
  <div class="bottom-nav">
    <BottomNavItem to="/" class="circle-icon" title="Content" icon="🌐"/>
    <BottomNavItem to="/courses/2" class="circle-icon" title="Java" icon="❤️‍"/>
    <BottomNavItem to="/prompt" class="circle-icon" title="Prompt" icon="🦾"/>
    <div v-if="currentUser" class="nav-item-wrapper">
      <div class="nav-item" @click="toggleUserMenu">
        <span class="icon">🧑🏻‍💻</span>
        <span class="title">{{ currentUser.username }}</span>
      </div>
      <div class="bottom-dropdown" v-if="isUserMenuOpen">
        <router-link to="/profile" class="dropdown-item" @click="closeUserMenu">
          <span class="item-icon">👤</span>
          Profile
        </router-link>
        <div class="dropdown-divider"></div>
        <a @click="handleLogout" class="dropdown-item">
          <span class="item-icon">🚪</span>
          Logout
        </a>
      </div>
    </div>
    <BottomNavItem
        v-if="!currentUser"
        to="/login"
        class="circle-icon"
        title="Login"
        icon="➡️"
    />
  </div>
</template>

<script>
import BottomNavItem from "./BottomNavItem.vue";

export default {
  components: {
    BottomNavItem,
  },
  data() {
    return {
      isUserMenuOpen: false
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    }
  },
  methods: {
    toggleUserMenu() {
      this.isUserMenuOpen = !this.isUserMenuOpen;
    },
    closeUserMenu() {
      this.isUserMenuOpen = false;
    },
    handleLogout() {
      this.$store.dispatch('auth/logout');
      this.$router.push('/login');
      this.closeUserMenu();
    }
  },
  mounted() {
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.nav-item-wrapper')) {
        this.closeUserMenu();
      }
    });
  }
};
</script>

<style scoped>
.bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: var(--my-black);
  display: flex;
  justify-content: space-around;
  align-items: center;
  z-index: 1001;
  border: none;
}

.nav-item-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex: 1;
}

.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 0;
  cursor: pointer;
  color: var(--my-white);
  text-decoration: none;
  opacity: 0.7;
  transition: all 0.3s ease;
  width: 100%;
  background: transparent;
}

.nav-item:hover {
  opacity: 1;
  background: rgba(255, 255, 255, 0.05);
}

.nav-item .icon {
  font-size: 20px;
  margin-bottom: 4px;
}

.nav-item .title {
  font-size: 12px;
}

.bottom-dropdown {
  position: absolute;
  bottom: calc(100% + 10px);
  right: 0;
  min-width: 140px;
  background: rgba(31, 31, 31, 0.98);
  backdrop-filter: blur(10px);
  border-radius: 8px;
  padding: 8px;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.1);
  margin-right: 10px;
}

.dropdown-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  color: var(--my-white);
  text-decoration: none;
  border-radius: 6px;
  transition: all 0.2s ease;
  cursor: pointer;
  opacity: 0.8;
}

.dropdown-item:hover {
  background: rgba(255, 255, 255, 0.1);
  opacity: 1;
}

.item-icon {
  font-size: 16px;
}

.dropdown-divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.1);
  margin: 4px 0;
}

.bottom-dropdown::after {
  content: '';
  position: absolute;
  bottom: -5px;
  right: 20px;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid rgba(31, 31, 31, 0.98);
}

@media (min-width: 768px) {
  .bottom-nav {
    display: none;
  }
}
</style>
